const AdvertiserEdit = () => import('@/modules/advertisers/views/AdvertiserEdit')
const AdvertiserIndex = () => import('@/modules/advertisers/views/AdvertiserIndex')
const AdvertiserShow = () => import('@/modules/advertisers/views/AdvertiserShow')

export default [
  {
    path: '/advertisers',
    name: 'advertisers.index',
    component: AdvertiserIndex,
    meta: { requiresAuthentication: true }
  },
  {
    path: '/advertisers/create',
    name: 'advertisers.create',
    component: AdvertiserEdit,
    meta: { requiresAuthentication: true }
  },
  {
    path: '/advertisers/:id',
    name: 'advertisers.show',
    component: AdvertiserShow,
    meta: { requiresAuthentication: true }
  },
  {
    path: '/advertisers/:id/edit',
    name: 'advertisers.edit',
    component: AdvertiserEdit,
    meta: { requiresAuthentication: true }
  }
]
